import { useAuth } from "@lib/auth/useAuth";
import { ACTIVE_CONSENTS_TYPE } from "@lib/constants/consents";
import { getRouteFromRoutesFile } from "@lib/constants/pagePaths";
import rootRoutes from "@app/_routes.json";
import { useGetMyProfile } from "@store/hooks";

type Config = {
    locale: string;
    pathname: string;
};

export const useHideEmailForm = ({ locale, pathname }: Config) => {
    const { isAuthenticated } = useAuth();
    const { data } = useGetMyProfile();

    const hasConsent = data?.activeConsentTypes?.includes(ACTIVE_CONSENTS_TYPE.NEWSLETTER);

    const createAccountPage = getRouteFromRoutesFile(rootRoutes, "create-account");

    const pagesToHideForm = [createAccountPage[locale], createAccountPage["en"]].filter(Boolean);
    const shouldHideOnPage = pagesToHideForm.some((path) => pathname?.includes(path));

    const hideFromAuthenticatedUserWithConsent = hasConsent && isAuthenticated;

    return shouldHideOnPage || hideFromAuthenticatedUserWithConsent;
};
